module.exports = __webpack_public_path__ + "img/MN.c38782be.svg";